import styled, { css } from "styled-components";
import { IconContext } from "react-icons";
import { FiArrowDown, FiArrowUp } from "react-icons/fi";
import { convertOnlyMinutes } from "../helpers";

const Heading = styled.h2`
  ${props => props.minutes && css`
    width: 30px;
  `};
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

const Button = styled.button`
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  appearance: none;
  outline: none;
  text-align: inherit;
  cursor: pointer;
`;

const Length = ({ length, setLength, timerRunning, content }) => {

  const decrement = () => {
    if (timerRunning || length <= 60) return;
    setLength(current => current - 60);
  };

  const increment = () => {
    if (timerRunning || length >= 3600) return;
    setLength(current => current + 60);
  };

  return (
    <div>
      <Heading>{content}</Heading>
      <IconWrapper>
        <IconContext.Provider value={{ size: "2em" }}>
          <Button>
            <FiArrowDown onClick={decrement} />
          </Button>
          <Heading minutes>{convertOnlyMinutes(length)}</Heading>
          <Button>
            <FiArrowUp onClick={increment} />
          </Button>
        </IconContext.Provider>
      </IconWrapper>
    </div>
  );
};

export default Length;